export type SelectToggleButtonProps = {
  photoId: number;
  isSelected: boolean;
  onToggle: (photoId: number, newState: boolean) => void;
  compact?: boolean;
};

export default function SelectToggleButton({ photoId, isSelected, onToggle, compact = false }: SelectToggleButtonProps) {
  const handleToggle = () => onToggle(photoId, !isSelected);

  if (compact) {
    return (
      <div
        onClick={handleToggle}
        title={isSelected ? 'Remove approval' : 'Approve this photo'}
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: isSelected ? '#2E75B6' : 'rgba(0,0,0,0.45)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: 16,
          fontWeight: 'bold',
          border: '2px solid rgba(255,255,255,0.8)',
          userSelect: 'none',
        }}
      >
        {isSelected ? '✓' : '+'}
      </div>
    );
  }

  return (
    <button
      onClick={handleToggle}
      style={{
        padding: '10px 24px',
        background: isSelected ? '#2E75B6' : '#555',
        color: 'white',
        border: 'none',
        borderRadius: 4,
        cursor: 'pointer',
        fontSize: 15,
        fontWeight: 600,
      }}
    >
      {isSelected ? 'Approved ✓' : 'Approve'}
    </button>
  );
}
